import React from "react";
import { Link } from "react-router-dom";
import { loginlog } from "../Constant/Index";

function Createpassword() {
  return (
    <>
      {/* Create New Password  */}
      <section className="login_sec overflow-hidden">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="auth_form">
              {/* <div className="mobileLogo">
                <Link to="/">
                  <figure>
                    <img src={logo} alt="weblogo" className="img-fluid" />
                    dddd
                  </figure>
                </Link>
              </div> */}
              <div className="heading_wrapper">
                <div className="webLogo">
                  <Link to="/">
                    <figure>
                      <img src={loginlog} alt="weblogo" className="img-fluid" />
                    </figure>
                  </Link>
                </div>
                <p className="tagline secondary-color font-weight-bold">
                  Powerful Hand
                </p>

                <h2 className="title primary-color">Create New Password</h2>
                <p className="primary-color font-weight-meduim">
                  Enter the email address associated with your account and we
                  will send you a password reset link.
                </p>
              </div>
              <form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="password"
                        placeholder="Password"
                        name="password"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="password"
                        placeholder="Password"
                        name="password"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="button-group">
                  <button className="milkyBtn w-100">Submit</button>
                </div>
             
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="showcase_column">
              {/* <div className="webLogo">
                <Link to="/">
                  <figure>
                    <img src={loginimg} alt="weblogo" className="img-fluid" />
                  </figure>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* ============================= */}
    </>
  );
}

export default Createpassword;
